import { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router";

import { useCall } from "@/hooks/useCall/useCall";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";
import { useTrack } from "@/hooks/useTrack/useTrack";
import { useTrackHelpers } from "@/hooks/useTrackHelpers/useTrackHelpers";
import { useBaseStore } from "@/store/store";
import { IDType } from "@aircall/tractor";
import { RedirectProps, SubRoute } from "./TabMenu.decl";

export function useRedirect({ disabledTabs }: RedirectProps) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to call info tab current location is disabled.
    if (disabledTabs.some((tab) => location.pathname.includes(tab))) {
      navigate("info");
    }
  }, [disabledTabs, location.pathname, navigate]);
}

export function useHandlers() {
  const navigate = useNavigate();
  const { track } = useTrack();

  const setEvaluationTabSource = useBaseStore(
    (store) => store.setEvaluationTabSource
  );
  const setShouldTrackEvaluationTabSource = useBaseStore(
    (store) => store.setShouldTrackEvaluationTabSource
  );

  const [currentTab, setCurrentTab] = useState<SubRoute | null>(null);

  // Avoids "Cannot update a component while rendering a different component warning" error. Might be a better way to handle this.
  useEffect(() => {
    if (currentTab) {
      setShouldTrackEvaluationTabSource(true);
      setEvaluationTabSource(currentTab);
    }
  }, [currentTab, setEvaluationTabSource, setShouldTrackEvaluationTabSource]);

  const {
    sentiment_displayed: sentimentDisplayed,
    key_topics_displayed: keyTopicsDisplayed,
    talk_ratio_displayed: talkRatioDisplayed,
    action_items_displayed: actionItemsDisplayed,
  } = useTrackHelpers();

  const { call } = useCall();
  const { line } = useGetLine();

  const onChangeTab = (value: IDType) => {
    const _value = value as SubRoute;

    setCurrentTab(_value);
    navigate(_value);

    switch (_value) {
      case "insights":
        track("conversation_insights_tab_opened", {
          call_uuid: call?.uuid,
          number_id: Number(line?.ID),
          sentiment_displayed: sentimentDisplayed,
          key_topics_displayed: keyTopicsDisplayed,
          talk_ratio_displayed: talkRatioDisplayed,
          action_items_displayed: actionItemsDisplayed,
        });
        break;
      case "evaluation":
        // We should handle this case inside the component itself.
        break;
      case "notes":
        track("conversation_note_tab_opened", {
          call_uuid: call?.uuid,
          number_id: Number(line?.ID),
        });
        break;
      case "info":
        track("conversation_info_tab_opened", {
          call_uuid: call?.uuid,
          number_id: Number(line?.ID),
        });
        break;
      default:
        break;
    }
  };

  return {
    onChangeTab,
  };
}
